import * as React from 'react'
import PropTypes from 'prop-types'
import type { InputDescriptionProps } from '../../../components/InputDescription'
import { useThemeStyles } from '../../../theming'
import type { InputCountProps } from '../InputCount'
import styles from './styles'

export interface BelowInputContainerProps {
  count?: React.ReactElement<InputCountProps>
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  description?: React.ReactElement<InputDescriptionProps>
  error?: React.ReactElement<InputDescriptionProps>
}

export function BelowInputContainer({
  count,
  'data-qa': dataQa,
  description,
  error,
}: BelowInputContainerProps) {
  const sx = useThemeStyles(styles)

  return error || count || description ? (
    <div css={sx.wrap} data-qa={dataQa}>
      {error || count || description}
    </div>
  ) : null
}

BelowInputContainer.propTypes = {
  count: PropTypes.node,
  description: PropTypes.node,
  error: PropTypes.node,
}

BelowInputContainer.displayName = 'BelowInputContainer'
